/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as a from "react";
import { NumericTextBox as o } from "../numerictextbox/NumericTextBox.mjs";
import v from "./HexInput.mjs";
import { Button as x } from "@progress/kendo-react-buttons";
import { caretAltExpandIcon as C } from "@progress/kendo-svg-icons";
import { provideLocalizationService as k, registerForIntl as E, registerForLocalization as M } from "@progress/kendo-react-intl";
import { colorGradientHex as r, messages as n, colorGradientR as l, colorGradientG as g, colorGradientB as c, colorGradientA as p, colorGradientToggleInputsButton as h } from "../messages/index.mjs";
const i = ["rgba", "rgb", "hex"];
class d extends a.Component {
  constructor(e) {
    super(e), this.onRgbaRChange = (t) => {
      this.dispatchRgbaChange({ r: t.value }, t);
    }, this.onRgbaGChange = (t) => {
      this.dispatchRgbaChange({ g: t.value }, t);
    }, this.onRgbaBChange = (t) => {
      this.dispatchRgbaChange({ b: t.value }, t);
    }, this.onRgbaAChange = (t) => {
      this.dispatchRgbaChange({ a: t.value }, t);
    }, this.state = { inputMode: e.defaultInputMode || i[1] };
  }
  render() {
    const e = k(this), t = e.toLanguageString(r, n[r]), s = e.toLanguageString(l, n[l]), m = e.toLanguageString(g, n[g]), b = e.toLanguageString(c, n[c]), u = e.toLanguageString(p, n[p]), f = e.toLanguageString(
      h,
      n[h]
    );
    return /* @__PURE__ */ a.createElement("div", { className: "k-colorgradient-inputs k-hstack" }, /* @__PURE__ */ a.createElement("div", { className: "k-vstack" }, /* @__PURE__ */ a.createElement(
      x,
      {
        "aria-label": f,
        fillMode: "flat",
        icon: "caret-alt-expand",
        svgIcon: C,
        className: "k-colorgradient-toggle-mode",
        onClick: this.onToggleModeChange.bind(this)
      }
    )), this.state.inputMode === "hex" && /* @__PURE__ */ a.createElement("div", { className: "k-vstack k-flex-1" }, /* @__PURE__ */ a.createElement(
      v,
      {
        hex: this.props.hex,
        onHexChange: this.props.onHexChange,
        disabled: this.props.disabled
      }
    ), /* @__PURE__ */ a.createElement("label", { className: "k-colorgradient-input-label" }, t)), (this.state.inputMode === "rgb" || this.state.inputMode === "rgba") && /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement("div", { className: "k-vstack" }, /* @__PURE__ */ a.createElement(
      o,
      {
        value: this.props.rgba.r,
        ariaLabel: String(this.props.rgba.r),
        min: 0,
        max: 255,
        spinners: !1,
        format: "n",
        onChange: this.onRgbaRChange,
        disabled: this.props.disabled
      }
    ), /* @__PURE__ */ a.createElement("label", { className: "k-colorgradient-input-label" }, s)), /* @__PURE__ */ a.createElement("div", { className: "k-vstack" }, /* @__PURE__ */ a.createElement(
      o,
      {
        value: this.props.rgba.g,
        ariaLabel: String(this.props.rgba.g),
        min: 0,
        max: 255,
        spinners: !1,
        format: "n",
        onChange: this.onRgbaGChange,
        disabled: this.props.disabled
      }
    ), /* @__PURE__ */ a.createElement("label", { className: "k-colorgradient-input-label" }, m)), /* @__PURE__ */ a.createElement("div", { className: "k-vstack" }, /* @__PURE__ */ a.createElement(
      o,
      {
        value: this.props.rgba.b,
        ariaLabel: String(this.props.rgba.b),
        min: 0,
        max: 255,
        spinners: !1,
        format: "n",
        onChange: this.onRgbaBChange,
        disabled: this.props.disabled
      }
    ), /* @__PURE__ */ a.createElement("label", { className: "k-colorgradient-input-label" }, b))), this.state.inputMode === "rgba" && /* @__PURE__ */ a.createElement("div", { className: "k-vstack" }, this.props.opacity && /* @__PURE__ */ a.createElement(
      o,
      {
        value: this.props.rgba.a,
        ariaLabel: String(this.props.rgba.a),
        min: 0,
        max: 1,
        step: 0.01,
        spinners: !1,
        format: "n2",
        onChange: this.onRgbaAChange,
        disabled: this.props.disabled
      }
    ), this.props.opacity && /* @__PURE__ */ a.createElement("label", { className: "k-colorgradient-input-label" }, u)));
  }
  dispatchRgbaChange(e, t) {
    const s = { ...this.props.rgba };
    e.r !== void 0 && (s.r = e.r), e.g !== void 0 && (s.g = e.g), e.b !== void 0 && (s.b = e.b), e.a !== void 0 && (s.a = e.a), this.props.onRgbaChange(s, t);
  }
  onToggleModeChange() {
    const e = i.length - 1 === i.indexOf(this.state.inputMode) ? 0 : i.indexOf(this.state.inputMode) + 1;
    if (this.props.opacity)
      this.setState({ inputMode: i[e] });
    else {
      const t = i[e] === "rgba" ? e + 1 : e;
      this.setState({ inputMode: i[t] });
    }
  }
}
E(d);
M(d);
export {
  d as default
};
